<template>
  <v-dialog
      v-if="!!state"
      v-model="state.dialog"
      min-width="800"
      max-width="900"
      persistent
  >
    <v-sheet max-height="800" class="overflow-y-auto pb-5" :color="color">
      <v-row>
        <v-col cols="1">
          <v-icon v-if="state.type === 'error'" :color="state.type" large>mdi-alert-circle</v-icon>
          <v-icon v-if="state.type === 'warning'" :color="state.type" large>mdi-alert-circle-outline</v-icon>
          <v-icon v-if="state.type === 'info'" :color="state.type" large>mdi-information-outline</v-icon>
        </v-col>
        <v-col cols="11">
          <v-list-item
              v-for="(message, i) in state.message" :key="i"
          >
            <v-list-item-content>
              <v-list-item-title v-text="message" class="text-wrap"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-0 mb-9"></v-divider>
          <v-row v-for="(item, i) in state.input_list" :key="i" class="px-0">
            <v-row v-if="item.input_type === 'input_scan'">
              <qr-code :text="item.value" :size="96"></qr-code>
              <v-chip class="ml-3 mt-9" label outlined>{{ item.label }}</v-chip>
              <!--              <v-chip class="ml-3 mt-9" label outlined>{{ item.name }}</v-chip>-->
              <v-chip class="ml-3 mt-9" label outlined>{{ item.value }}</v-chip>
            </v-row>
            <v-text-field
                v-if="item.input_type === 'string'"
                :ref="item.name"
                v-model="item.value"
                :label="item.label"
                outlined
                clearable
                dense
                class="mt-2 mr-5"
            ></v-text-field>
            <v-textarea
                v-if="item.input_type === 'text'"
                :ref="item.name"
                v-model="item.value"
                :label="item.label"
                outlined
                clearable
                dense
                class="mt-2 mr-5"
            ></v-textarea>
            <v-autocomplete
                v-if="item.input_type === 'select'"
                :ref="item.name"
                v-model="item.value"
                :items="item.data"
                :label="item.label"
                :item-text="item.item_text"
                :item-label="item.item_label"
                outlined
                clearable
                dense
                class="mt-2 mr-5"
            ></v-autocomplete>
            <v-checkbox
                v-if="item.input_type === 'checkbox'"
                v-model="item.value"
                :label="item.label"
                dense
                class="mt-2 mr-5"
            >
            </v-checkbox>
            <v-file-input
                v-if="item.input_type === 'input_file'"
                :ref="item.name"
                v-model="item.value"
                :label="item.label"
                outlined
                clearable
                dense
                class="mt-2 mr-5"
            ></v-file-input>
          </v-row>
        </v-col>
      </v-row>
      <slot name="action" :state="state">
        <v-row dense class="justify-space-between mt-5 pr-8">
          <v-col cols="2" v-for="action of state.action_list" :key="action.uid"
                 class="d-flex align-center justify-center">
            <qr-code v-if="!!action.uid" :text="action.uid" :size="96"></qr-code>
          </v-col>
        </v-row>
        <v-row dense class="justify-space-between pr-8">
          <v-col cols="2" v-for="action of state.action_list" :key="action.uid"
                 class="d-flex align-center justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    @click="state.dialog = false; runAction(action.action)"
                    outlined
                    :width="!!action.uid ? 96+16 : ''"
                    v-on="on"
                    small
                >
                  {{ action.label }}
                </v-btn>
              </template>
              <small v-if="!!action.text">{{ action.text }}</small>
            </v-tooltip>
          </v-col>
          <v-spacer v-if="state.action_list.length === 0"></v-spacer>
          <v-col cols="1" v-if="state.action_list.length === 0" class="d-flex align-center justify-center">
            <v-btn
                color="grey darken-1"
                @click="state.dialog = false"
                outlined
                small
            >
              Cancel
            </v-btn>
          </v-col>
          <v-col cols="1" v-if="state.type === 'warning' && state.action_list.length === 0"
                 class="d-flex align-center justify-center">
            <v-btn
                @click="onAgree"
                outlined
                small
            >
              OK
            </v-btn>
          </v-col>
        </v-row>
      </slot>
    </v-sheet>
  </v-dialog>
</template>

<script>
import {useAggregateStore} from "@/store/CommonStore/baseAggregateStore";
import {defineStore} from "pinia";
import {v4 as uuidv4} from "uuid";
// import {useScannerStore} from "@/store/CommonStore/scannerStore";

export const useConfirmStore = function (storeName) {
  return defineStore(storeName, {
        state: () => ({
          dialog: false,
          message: null,
          request: {},
          type: 'info',
          timeout: -1,
          action_list: [],
          input_list: [],
          dto_action_command: null,
          self: null,
          selected_uid_list: [],
          current_uid: null,

          scannerInput: '',
          scannerCount: 0,
          scannerConfirmInput: '',
          scannerConfirmCount: 0,
          scannerMobileInput: '',
          scannerMobileCount: 0,
          scanBufferMobile: '',
          scanBuffer: '',
          scanning: false,
        }),
        getters: {},
        actions: {
          callReceive() {
            // console.log('useConfirmStore callReceive', this.self.$refs)
            this.self.$nextTick(() => {
              for (let item of this.input_list) {
                if (item.focus === true) {
                  if (!!this.self.$refs[item.name] && !!this.self.$refs[item.name][0]) {
                    this.self.$refs[item.name][0].$refs.input.focus()
                  }
                }
              }
            })
          },
        },
      }
  )
}

export default {
  name: 'CommonConfirmDialog',

  props: {
    storeName: {type: [String], default: 'CommonConfirmDialog'},
  },

  components: {},

  computed: {
    dialog() {
      return this.state.dialog
    },
    color() {
      if (this.state.type == 'warning')
        return 'orange lighten-5'
      if (this.state.type == 'error')
        return 'red lighten-5'
      if (this.state.type == 'info')
        return 'blue lighten-5'
    }
  },

  methods: {
    handleKeyDown(event) {
      // console.log('handleKeyDown', event, this.state.dialog)
      if (!this.state.dialog)
        return
      // console.log('handleKeyDown', event)
      if ('PageUp' === event.key) {
        event.preventDefault()
        event.stopPropagation()
        this.state.scanning = true
        this.state.scanBuffer = ''
        // console.log('handleKeyDown prefixScan', event)
        return
      }
      if (event.key === 'PageDown' && this.state.scanning) {
        // console.log('handleKeyDown suffixScan', event, this.state.scanBuffer)
        this.state.scanBuffer = this.state.scanBuffer.replace('Unidentified', '')
        this.state.scanBuffer = this.state.scanBuffer.replace('matmat', 'mat-82587298-8aed-43de-b60c-6b2517180b1b')
        this.state.scanBuffer = this.state.scanBuffer.replace('materr', 'mat-82587298-8aed-43de-b60c-6b2517180b11')
        this.state.scanBuffer = this.state.scanBuffer.replace('locloc', 'loc-1af8e4be-911a-4492-98ec-881e5a4feb11')
        this.state.scanBuffer = this.state.scanBuffer.replace('locpan', 'loc-1af8e4be-911a-4492-98ec-881e5a4febdd')
        this.state.scanBuffer = this.state.scanBuffer.replace('locerr', 'loc-1af8e4be-911a-4492-98ec-000000000000')
        this.state.scanBuffer = this.state.scanBuffer.replace('test-mpn', '1N4747A-TR')
        this.state.scanBuffer = this.state.scanBuffer.replace('test-pn', 'test_new_pn_1.2')

        if (this.state.scanBuffer === null || this.state.scanBuffer === undefined || this.state.scanBuffer === '')
          return
        let uid = this.state.scanBuffer.slice(4)
        let prefix = this.state.scanBuffer.slice(0, 4)
        let input_list = []
        for (let item of this.state.input_list) {
          if (item.input_type === 'input_scan') {
            item.value = this.state.scanBuffer
          }
          input_list.push(item)
        }
        this.state.input_list = input_list
        for (let action of this.state.action_list) {
          // console.log('action_list', this.state.scanBuffer, action.uid)
          if (action.uid === this.state.scanBuffer && !!action.action) {
            this.runAction(action.action)
            break
          }
        }
        this.state.scanBuffer = ''
        this.state.scanning = false
        event.preventDefault()
        event.stopPropagation()
        return
      }
      if (event.key === 'PageDown' && this.state.scanning)
        this.state.scanning = false
      if (event.key.length === 1 && this.state.scanning) {
        // console.log('CommonConfirmDialog', event)
        event.preventDefault()
        event.stopPropagation()
        this.state.scanBuffer += event.key
      }
    },
    runAction(action) {
      // console.log('runAction', action, this)
      for (const child of this.$parent.$children) {
        if (!!child[action]) {
          child[action](this.state.input_list)
          this.state.dialog = false
          return
        }
        for (const sub_child of child.$children) {
          if (!!sub_child[action]) {
            sub_child[action](this.state.input_list)
            this.state.dialog = false
            return
          }
        }
      }
      if (!!this.state.dto_action_command) {
        this.aggregateStore.fetchAction({
          storeName: null,
          dtoActionCommand: this.state.dto_action_command,
          uidItem: this.state.current_uid,
          uidSelected: this.state.selected_uid_list,
          actionName: action,
          actionUid: uuidv4(),
          data: this.state.input_list,
          callBack: null,
          callReceive: null
        })
        this.state.dialog = false
      }
    },
    embeddedCancel() {
      // console.log('embeddedCancel')
      this.state.dialog = false
    },
    onAgree() {
      this.confirm_request.request['dto']['confirm'] = true
      this.aggregateStore.fetchRequest()
      this.state.dialog = false
    },
  },

  setup({storeName}) {
    let state = useConfirmStore(storeName)()
    return {state}
  },

  mounted() {
    // console.log('mounted CommonConfirmDialog', this.storeName, this.state, this.$options.name)
    this.aggregateStore = useAggregateStore()
    this.state.self = this

    this.storeConfirmStore = useConfirmStore('CommonConfirmDialog')()

    window.addEventListener('keydown', this.handleKeyDown)
  },

  created() {
  },

  data() {
    return {
      aggregateStore: null,
      // scannerStore: null,
      test: null,
    }
  },
}

</script>


<style scoped lang="scss">
</style>